export default {
    attribute: {
        url: '',
        width: 40,
        height: 40,
        fit: 'fill',
        preview: false,
        autoRotate: false,
        rotateDuration: 2,
        bgColor: 'rgba(0,0,0,0)',
    },
    // interaction: {
    //     intType: 'none'
    // }
}